import { useQuery, useMutation } from 'react-query';
import {
  getMealPlanCategories,
  getMealPlanListPerCategory,
  saveMealPlan,
  saveMealPlanBulk,
  getMealPlanDetail,
  updateMealPlan,
  deleteMealPlan,
  saveMealPlanImage,
  deleteMealPlanItems,
  updateMealPlanSort,
  getMealPlanSurveyStats
} from 'apis';
import { TMealPlanCategory, TMealPlans, TMealPlan, TSurveyStats } from 'interfaces/mealPlan';

// 식단표 카테고리 조회
export const useMealPlanCategories = () => {
  return useQuery<TMealPlanCategory[]>(['getMealPlanCategories'], getMealPlanCategories);
};

// 식단표 조회 (카테고리별)
export const useMealPlanListPerCategory = () => {
  return useMutation<TMealPlans[], unknown, string>(['getMealPlanListPerCategory'], (serveDate: string) => {
    return getMealPlanListPerCategory(serveDate);
  });
};

// 식단표 등록
export const useSaveMealPlan = () => {
  return useMutation(['saveMealPlan'], (params: unknown) => saveMealPlan(params));
};

// 식단표 bulk 록
export const useSaveMealPlanBulk = () => {
  return useMutation(['saveMealPlanBulk'], (params: unknown) => saveMealPlanBulk(params));
};

// 식단표 상세 조회
export const useMealPlanDetail = () => {
  return useMutation<TMealPlan, unknown, string>(['getMealPlanDetail'], (mealPlanIdx?: string) => getMealPlanDetail(mealPlanIdx));
};

// 식단표 수정
export const useUpdateMealPlan = () => {
  return useMutation(['updateMealPlan'], ({ mealPlanIdx, params }: { mealPlanIdx: string; params: unknown }) => {
    return updateMealPlan(mealPlanIdx, params);
  });
};

// 식단표 비활성화
export const useDeleteMealPlan = () => {
  return useMutation(['deleteMealPlan'], (mealPlanIdx: string) => deleteMealPlan(mealPlanIdx));
};

// 식단표 이미지 업로드
export const useSaveMealPlanImage = () => {
  return useMutation(['saveMealPlanImage'], ({ mealPlanIdx, params }: { mealPlanIdx: number; params: unknown }) => {
    return saveMealPlanImage(mealPlanIdx, params);
  });
};

// 식단표 식단 항목 비활성화
export const useDeleteMealPlanItems = () => {
  return useMutation(['deleteMealPlanItems'], (mealPlanItemIdx: number) => deleteMealPlanItems(mealPlanItemIdx));
};

// 식단표 순서 변경
export const useUpdateMealPlanSort = () => {
  return useMutation(['updateMealPlanSort'], ({ mealPlanIdx, params }: { mealPlanIdx: number; params: unknown }) => {
    return updateMealPlanSort(mealPlanIdx, params);
  });
};

// 식단표 순서 변경
export const useGetMealPlanSurveyStats = () => {
  return useMutation<TSurveyStats, unknown, { startDate: string; endDate: string }>(
    ['getMealPlanSurveyStats'],
    (params: { startDate: string; endDate: string }) => {
      return getMealPlanSurveyStats(params);
    }
  );
};
